import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        padding: ", " 0;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1h3tecd-0"
})(["padding:", " 0;", ""], rem(8), media.sm(_templateObject(), rem(16)));
export default Container;